export const companyConfig = {
  name: "Haus- & Gartenservice Kochon",
  legalName: "Haus- & Gartenservice Kochon", // Falls abweichend
  owner: "Joachim Kochon",
  contact: {
    address: {
      street: "Bielertstr. 7",
      zip: "51379",
      city: "Leverkusen",
      country: "Deutschland",
    },
    phone: "0214 31 26 54 40",
    mobile: "01638461273", // Optional
    email: "kochonjoachim@yahoo.de",
    website: "www.haus-gartenservice-kochon.de",
  },
  legal: {
    taxId: "230/5189/1656", // Umsatzsteuer-ID
    commercialRegister: {
      court: "Amtsgericht Leverkusen",
      number: "HRB XXXXX",
    },
    chamber: {
      name: "Handwerkskammer zu Köln",
      qualification: "Gärtnermeister",
    },
  },
  businessHours: [
    { day: "Montag", hours: "8:00 - 17:00 Uhr" },
    { day: "Dienstag", hours: "8:00 - 17:00 Uhr" },
    { day: "Mittwoch", hours: "8:00 - 17:00 Uhr" },
    { day: "Donnerstag", hours: "8:00 - 17:00 Uhr" },
    { day: "Freitag", hours: "8:00 - 17:00 Uhr" },
    { day: "Samstag", hours: "Nach Vereinbarung" },
    { day: "Sonntag", hours: "Geschlossen" },
  ],
  socialMedia: [
    { platform: "Facebook", url: "https://facebook.com/gartenmeisterkochon" },
    { platform: "Instagram", url: "https://instagram.com/gartenmeisterkochon" },
  ],
  location: {
    city: "Leverkusen",
    region: "Nordrhein-Westfalen",
  },
};
